// extracted by mini-css-extract-plugin
export default {"card":"MonitoringOptionCard_card__DI5mD","checkbox":"MonitoringOptionCard_checkbox__rbSjG","title":"MonitoringOptionCard_title__K9Hs3"};